import axios from './axios'

const service = function (prarms, callbackPrarms) {
  callbackPrarms = callbackPrarms || {}
  return new Promise(function(resolve, reject) {
    axios(prarms).then(
      function(res) {
        if(res?.data?.code==403)
        {
        window.history.replaceState(null, document.title, "/403")
        }
        resolve({ callbackPrarms, res })
      },
      function(error) {
        reject({ callbackPrarms, error })
      }
    )
  })
}
export default service
